module.exports = __webpack_public_path__ + "fonts/gt-america-standard-light.30152cb.ttf";